// import enquire from 'enquire-js';
// import { insertElementBefore, insertElementAfter } from '../helpers';

// // main vars
// const headerSearch = document.querySelector('.site-header__search'),
// 	headerSearchToggle = document.querySelector('.site-header__search-toggle'),
// 	langSelector = document.querySelector('.site-header__lang-selector'),
// 	logoBar = document.querySelector('.site-header__logo-bar .wrapper'),
// 	mobileMenuContainer = document.querySelector('.mobile-menu-container'),
// 	siteFooter = document.querySelector('.site-footer'),
// 	footerPrivacyMenu = document.querySelector('.site-footer__privacy-menu'),
// 	footerSocialMenu = document.querySelector('.site-footer__social-links');

// export default enquire.register('screen and ( max-width: 1024px )', {
// 	match: () => {
// 		insertElementBefore(headerSearchToggle, logoBar);
// 		logoBar.insertAdjacentElement('afterbegin', langSelector);
// 		mobileMenuContainer.insertAdjacentElement('beforeend', footerPrivacyMenu);
// 		mobileMenuContainer.insertAdjacentElement('beforeend', footerSocialMenu);
// 	},
// 	unmatch: () => {
// 		insertElementBefore(headerSearchToggle, headerSearch);
// 		insertElementAfter(langSelector, headerSearch);
// 		insertElementBefore(footerPrivacyMenu, siteFooter);
// 	}
// });
